import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from 'class-variance-authority';
import { std } from '@funkey/shared/utils';
const variants = cva('', {
  variants: {
    status: {
      positive: 'bg-turqoise-50 text-turqoise-500',
      passive: 'bg-blue-100 text-blue-500',
      pending: 'bg-yellow-100 text-yellow-600',
      negative: 'bg-orange-50 text-orange-700'
    }
  },
  defaultVariants: {
    status: 'passive'
  }
});
namespace StatusLabel {
  export type Variant = NonNullable<VariantProps<typeof variants>['status']>;
}
function StatusLabel(props) {
  const $ = _c(5);
  let t0;
  if ($[0] !== props) {
    t0 = variants({
      className: ["rounded-xs w-fit p-2 text-2xs font-medium uppercase tracking-[1.7px]", props.className],
      status: "statusMap" in props ? std.Object.keys(props.statusMap).find(status => {
        const options = props.statusMap[status];
        if (typeof options === "string") {
          return options === props.children;
        }
        if (Array.isArray(options)) {
          return options.includes(props.children);
        }
        return false;
      }) : props.status
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children || $[3] !== t0) {
    t1 = <span className={t0}>{props.children}</span>;
    $[2] = props.children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export default StatusLabel;